/**
 * 发票VO
 */
export class Invoice {
  /**
   * @param {Object} data
   */
  constructor(data) {
    this._data = data
    this.className = 'Invoice'
  }

  get uuid() {
    return this._data.uuid
  }
  set uuid(uuid) {
    this._data.uuid = uuid
  }
  get version() {
    return this._data.version
  }
  set version(version) {
    this._data.version = version
  }
  get batchNo() {
    return this._data.batchNo
  }
  set batchNo(batchNo) {
    this._data.batchNo = batchNo
  }
  get vat() {
    return this._data.vat
  }
  set vat(vat) {
    this._data.vat = vat
  }
  get active() {
    return this._data.active
  }
  set active(active) {
    this._data.active = active
  }
  get tax() {
    return this._data.tax
  }
  set tax(tax) {
    this._data.tax = tax
  }
  get merged() {
    return this._data.merged
  }
  set merged(merged) {
    this._data.merged = merged
  }
  get mergeNo() {
    return this._data.mergeNo
  }
  set mergeNo(mergeNo) {
    this._data.mergeNo = mergeNo
  }
  get invoiceId() {
    return this._data.invoiceId
  }
  set invoiceId(invoiceId) {
    this._data.invoiceId = invoiceId
  }
  get invoiceType() {
    return this._data.invoiceType
  }
  set invoiceType(invoiceType) {
    this._data.invoiceType = invoiceType
  }
  get clearingState() {
    return this._data.clearingState
  }
  set clearingState(clearingState) {
    this._data.clearingState = clearingState
  }
  get ar() {
    return this._data.ar
  }
  set ar(ar) {
    this._data.ar = ar
  }
  get invoiceNo() {
    return this._data.invoiceNo
  }
  set invoiceNo(invoiceNo) {
    this._data.invoiceNo = invoiceNo
  }
  get invoiceDate() {
    return this._data.invoiceDate
  }
  set invoiceDate(invoiceDate) {
    this._data.invoiceDate = invoiceDate
  }
  get accountId() {
    return this._data.accountId
  }
  set accountId(accountId) {
    this._data.accountId = accountId
  }
  get title() {
    return this._data.title
  }
  set title(title) {
    this._data.title = title
  }
  get receiptInvoiceTitle() {
    return this._data.receiptInvoiceTitle
  }
  set receiptInvoiceTitle(receiptInvoiceTitle) {
    this._data.receiptInvoiceTitle = receiptInvoiceTitle
  }
  get currency() {
    return this._data.currency
  }
  set currency(currency) {
    this._data.currency = currency
  }
  get amount() {
    return this._data.amount
  }
  set amount(amount) {
    this._data.amount = amount
  }
  get chineseAmount() {
    return this._data.chineseAmount
  }
  set chineseAmount(chineseAmount) {
    this._data.chineseAmount = chineseAmount
  }
  get rate() {
    return this._data.rate
  }
  set rate(rate) {
    this._data.rate = rate
  }
  get chargeCurrency1() {
    return this._data.chargeCurrency1
  }
  set chargeCurrency1(chargeCurrency1) {
    this._data.chargeCurrency1 = chargeCurrency1
  }
  get chargeExchangeRate1() {
    return this._data.chargeExchangeRate1
  }
  set chargeExchangeRate1(chargeExchangeRate1) {
    this._data.chargeExchangeRate1 = chargeExchangeRate1
  }
  get chargeCurrency2() {
    return this._data.chargeCurrency2
  }
  set chargeCurrency2(chargeCurrency2) {
    this._data.chargeCurrency2 = chargeCurrency2
  }
  get chargeExchangeRate2() {
    return this._data.chargeExchangeRate2
  }
  set chargeExchangeRate2(chargeExchangeRate2) {
    this._data.chargeExchangeRate2 = chargeExchangeRate2
  }
  get invoiceDemand() {
    return this._data.invoiceDemand
  }
  set invoiceDemand(invoiceDemand) {
    this._data.invoiceDemand = invoiceDemand
  }
  get remark() {
    return this._data.remark
  }
  set remark(remark) {
    this._data.remark = remark
  }
  get printed() {
    return this._data.printed
  }
  set printed(printed) {
    this._data.printed = printed
  }
  get revoked() {
    return this._data.revoked
  }
  set revoked(revoked) {
    this._data.revoked = revoked
  }
  get revokedBy() {
    return this._data.revokedBy
  }
  set revokedBy(revokedBy) {
    this._data.revokedBy = revokedBy
  }
  get revokedDate() {
    return this._data.revokedDate
  }
  set revokedDate(revokedDate) {
    this._data.revokedDate = revokedDate
  }
  get inputBy() {
    return this._data.inputBy
  }
  set inputBy(inputBy) {
    this._data.inputBy = inputBy
  }
  get inputDate() {
    return this._data.inputDate
  }
  set inputDate(inputDate) {
    this._data.inputDate = inputDate
  }
  get inputByDep() {
    return this._data.inputByDep
  }
  set inputByDep(inputByDep) {
    this._data.inputByDep = inputByDep
  }
  get branchId() {
    return this._data.branchId
  }
  set branchId(branchId) {
    this._data.branchId = branchId
  }
  get taxAccount() {
    return this._data.taxAccount
  }
  set taxAccount(taxAccount) {
    this._data.taxAccount = taxAccount
  }
  get bank() {
    return this._data.bank
  }
  set bank(bank) {
    this._data.bank = bank
  }
  get bankAccount() {
    return this._data.bankAccount
  }
  set bankAccount(bankAccount) {
    this._data.bankAccount = bankAccount
  }
  get address() {
    return this._data.address
  }
  set address(address) {
    this._data.address = address
  }
  get telephone() {
    return this._data.telephone
  }
  set telephone(telephone) {
    this._data.telephone = telephone
  }
  get pol() {
    return this._data.pol
  }
  set pol(pol) {
    this._data.pol = pol
  }
  get pod() {
    return this._data.pod
  }
  set pod(pod) {
    this._data.pod = pod
  }
  get pod2() {
    return this._data.pod2
  }
  set pod2(pod2) {
    this._data.pod2 = pod2
  }
  get jobNo() {
    return this._data.jobNo
  }
  set jobNo(jobNo) {
    this._data.jobNo = jobNo
  }
  get mbl() {
    return this._data.mbl
  }
  set mbl(mbl) {
    this._data.mbl = mbl
  }
  get customerRefNo() {
    return this._data.customerRefNo
  }
  set customerRefNo(customerRefNo) {
    this._data.customerRefNo = customerRefNo
  }
  get etd() {
    return this._data.etd
  }
  set etd(etd) {
    this._data.etd = etd
  }
  get eta() {
    return this._data.eta
  }
  set eta(eta) {
    this._data.eta = eta
  }
  get vesselVoyage() {
    return this._data.vesselVoyage
  }
  set vesselVoyage(vesselVoyage) {
    this._data.vesselVoyage = vesselVoyage
  }
  get partCargo() {
    return this._data.partCargo
  }
  set partCargo(partCargo) {
    this._data.partCargo = partCargo
  }
  get partChargeName() {
    return this._data.partChargeName
  }
  set partChargeName(partChargeName) {
    this._data.partChargeName = partChargeName
  }
  get partQuantity() {
    return this._data.partQuantity
  }
  set partQuantity(partQuantity) {
    this._data.partQuantity = partQuantity
  }
  get partUnitPrice() {
    return this._data.partUnitPrice
  }
  set partUnitPrice(partUnitPrice) {
    this._data.partUnitPrice = partUnitPrice
  }
  get partCurrency() {
    return this._data.partCurrency
  }
  set partCurrency(partCurrency) {
    this._data.partCurrency = partCurrency
  }
  get partAmount() {
    return this._data.partAmount
  }
  set partAmount(partAmount) {
    this._data.partAmount = partAmount
  }
  get partAmount2() {
    return this._data.partAmount2
  }
  set partAmount2(partAmount2) {
    this._data.partAmount2 = partAmount2
  }
  get excludingTaxAmount() {
    return this._data.excludingTaxAmount
  }
  set excludingTaxAmount(excludingTaxAmount) {
    this._data.excludingTaxAmount = excludingTaxAmount
  }
  get taxRate() {
    return this._data.taxRate
  }
  set taxRate(taxRate) {
    this._data.taxRate = taxRate
  }
  get taxAmount() {
    return this._data.taxAmount
  }
  set taxAmount(taxAmount) {
    this._data.taxAmount = taxAmount
  }
  get buyerTaxAccount() {
    return this._data.buyerTaxAccount
  }
  set buyerTaxAccount(buyerTaxAccount) {
    this._data.buyerTaxAccount = buyerTaxAccount
  }
  get buyerBank() {
    return this._data.buyerBank
  }
  set buyerBank(buyerBank) {
    this._data.buyerBank = buyerBank
  }
  get buyerBankAccount() {
    return this._data.buyerBankAccount
  }
  set buyerBankAccount(buyerBankAccount) {
    this._data.buyerBankAccount = buyerBankAccount
  }
  get buyerAddress() {
    return this._data.buyerAddress
  }
  set buyerAddress(buyerAddress) {
    this._data.buyerAddress = buyerAddress
  }
  get buyerTelephone() {
    return this._data.buyerTelephone
  }
  set buyerTelephone(buyerTelephone) {
    this._data.buyerTelephone = buyerTelephone
  }
  get payee() {
    return this._data.payee
  }
  set payee(payee) {
    this._data.payee = payee
  }
  get auditor() {
    return this._data.auditor
  }
  set auditor(auditor) {
    this._data.auditor = auditor
  }
  get exportToInterface() {
    return this._data.exportToInterface
  }
  set exportToInterface(exportToInterface) {
    this._data.exportToInterface = exportToInterface
  }
  get mergeType() {
    return this._data.mergeType
  }
  set mergeType(mergeType) {
    this._data.mergeType = mergeType
  }
  get invoiceState() {
    return this._data.invoiceState
  }
  set invoiceState(invoiceState) {
    this._data.invoiceState = invoiceState
  }
  get remark2() {
    return this._data.remark2
  }
  set remark2(remark2) {
    this._data.remark2 = remark2
  }
  get sellTitle() {
    return this._data.sellTitle
  }
  set sellTitle(sellTitle) {
    this._data.sellTitle = sellTitle
  }
  get valInvoiceCode() {
    return this._data.valInvoiceCode
  }
  set valInvoiceCode(valInvoiceCode) {
    this._data.valInvoiceCode = valInvoiceCode
  }
  get makeType() {
    return this._data.makeType
  }
  set makeType(makeType) {
    this._data.makeType = makeType
  }
  get sendStatus() {
    return this._data.sendStatus
  }
  set sendStatus(sendStatus) {
    this._data.sendStatus = sendStatus
  }
  get downloads() {
    return this._data.downloads
  }
  set downloads(downloads) {
    this._data.downloads = downloads
  }
  get webOfdUrl() {
    return this._data.webOfdUrl
  }
  set webOfdUrl(webOfdUrl) {
    this._data.webOfdUrl = webOfdUrl
  }
  get webXmlUrl() {
    return this._data.webXmlUrl
  }
  set webXmlUrl(webXmlUrl) {
    this._data.webXmlUrl = webXmlUrl
  }
  get webPdfUrl() {
    return this._data.webPdfUrl
  }
  set webPdfUrl(webPdfUrl) {
    this._data.webPdfUrl = webPdfUrl
  }
  get webPdfFile() {
    return this._data.webPdfFile
  }
  set webPdfFile(webPdfFile) {
    this._data.webPdfFile = webPdfFile
  }
  get returnTaxCode() {
    return this._data.returnTaxCode
  }
  set returnTaxCode(returnTaxCode) {
    this._data.returnTaxCode = returnTaxCode
  }
  get returnTaxMsg() {
    return this._data.returnTaxMsg
  }
  set returnTaxMsg(returnTaxMsg) {
    this._data.returnTaxMsg = returnTaxMsg
  }
  get review() {
    return this._data.review
  }
  set review(review) {
    this._data.review = review
  }
  get reviewDate() {
    return this._data.reviewDate
  }
  set reviewDate(reviewDate) {
    this._data.reviewDate = reviewDate
  }
  get exportToGoldenTax() {
    return this._data.exportToGoldenTax
  }
  set exportToGoldenTax(exportToGoldenTax) {
    this._data.exportToGoldenTax = exportToGoldenTax
  }
  get actualReceiptDate() {
    return this._data.actualReceiptDate
  }
  set actualReceiptDate(actualReceiptDate) {
    this._data.actualReceiptDate = actualReceiptDate
  }
  get beredInvoiceUuid() {
    return this._data.beredInvoiceUuid
  }
  set beredInvoiceUuid(beredInvoiceUuid) {
    this._data.beredInvoiceUuid = beredInvoiceUuid
  }
  get cnnoticeNo() {
    return this._data.cnnoticeNo
  }
  set cnnoticeNo(cnnoticeNo) {
    this._data.cnnoticeNo = cnnoticeNo
  }
  get bankCurrency() {
    return this._data.bankCurrency
  }
  set bankCurrency(bankCurrency) {
    this._data.bankCurrency = bankCurrency
  }
  get specificConstraintType() { // 特定约束类型
    return this._data.specificConstraintType
  }
  set specificConstraintType(specificConstraintType) {
    this._data.specificConstraintType = specificConstraintType
  }
  // get redOffsetState() { // 红字申请状态 0未申请、1申请中、2成功、3失败
  //   return this._data.redOffsetState
  // }
  // set redOffsetState(redOffsetState) {
  //   this._data.redOffsetState = redOffsetState || 0
  // }
  get redOffsetReason() { // 红冲原因
    return this._data.redOffsetReason
  }
  set redOffsetReason(redOffsetReason) {
    this._data.redOffsetReason = redOffsetReason
  }
  // get redBillNo() { // 确认单编号
  //   return this._data.redBillNo
  // }
  // set redBillNo(redBillNo) {
  //   this._data.redBillNo = redBillNo
  // }
  // get redBillUuid() { // 确认单uuid
  //   return this._data.redBillUuid
  // }
  // set redBillUuid(redBillUuid) {
  //   this._data.redBillUuid = redBillUuid
  // }
  get sendState() {
    return this._data.sendState
  }
  set sendState(sendState) {
    this._data.sendState = sendState
  }
  get feedbackUniqueId() {
    return this._data.feedbackUniqueId
  }
  set feedbackUniqueId(feedbackUniqueId) {
    this._data.feedbackUniqueId = feedbackUniqueId
  }
  get jdyxkSyncStatus() {
    return this._data.jdyxkSyncStatus
  }
  set jdyxkSyncStatus(jdyxkSyncStatus) {
    this._data.jdyxkSyncStatus = jdyxkSyncStatus || 0
  }
  get jdyxkSyncFailReason() {
    return this._data.jdyxkSyncFailReason
  }
  set jdyxkSyncFailReason(jdyxkSyncFailReason) {
    this._data.jdyxkSyncFailReason = jdyxkSyncFailReason
  }
  get displaySell() { // 展示销售方银行账号
    return this._data.displaySell
  }
  set displaySell(displaySell) {
    this._data.displaySell = displaySell || false
  }
  get displayBuyer() { // 展示购买方银行账号
    return this._data.displayBuyer
  }
  set displayBuyer(displayBuyer) {
    this._data.displayBuyer = displayBuyer || false
  }
  get downloadSize() {
    return this._data.downloadSize
  }
  set downloadSize(downloadSize) {
    this._data.downloadSize = downloadSize
  }
  get invoiceNature() {
    return this._data.invoiceNature
  }
  set invoiceNature(invoiceNature) {
    this._data.invoiceNature = invoiceNature || 0
  }
}
